import React from 'react';
import { assertNever } from '../../../utils/helpers';

import { museum } from '../../../data';
import { ROutroLocalMuseumTranscriptDemo } from './r-outro-local-museum-demo';
import { ROutroLocalMuseumTranscriptBrighton } from './r-outro-local-museum-brighton';
import { ROutroLocalMuseumTranscriptMunch } from './r-outro-local-museum-munch';
import { ROutroLocalMuseumTranscriptCop26 } from './r-outro-local-museum-cop26';


const Transcript = (museum.slug === 'demo') ? ROutroLocalMuseumTranscriptDemo
                 : (museum.slug === 'brighton') ? ROutroLocalMuseumTranscriptBrighton
                 : (museum.slug === 'munch') ? ROutroLocalMuseumTranscriptMunch
                 : (museum.slug === 'mpu') ? ROutroLocalMuseumTranscriptDemo
                 : (museum.slug === 'cop-26') ? ROutroLocalMuseumTranscriptCop26
                 : assertNever(museum.slug);


const ROutroLocalMuseumTranscript: React.FC = () => {
  return <Transcript />;
};

export {
  ROutroLocalMuseumTranscript,
};
